module.exports = __webpack_public_path__ + "img/instructions.1186bbe5.svg";